var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#8BAA36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79883 8.89566V13.9857V14.0884V13.9857C8.79883 15.439 9.43295 16.7258 10.4161 17.5585C10.8969 17.9658 11.2145 18.5156 11.2145 19.1259V27.6223C11.2145 28.5668 12.0262 29.3334 13.0263 29.3334C14.0264 29.3334 14.838 28.5668 14.838 27.6223V19.1259C14.838 18.5156 15.1557 17.9658 15.6364 17.5585C16.6196 16.7258 17.2537 15.439 17.2537 13.9857V8.89566V13.9857",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0254 14.5038V8.79999",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3322 9.99973C29.3322 9.37004 28.7911 8.85898 28.1243 8.85898H26.9165C24.9151 8.85898 23.293 10.391 23.293 12.2812V19.1258C23.293 20.6133 24.3039 21.867 25.7087 22.3381V27.6221C25.7087 28.5667 26.5203 29.3332 27.5204 29.3332C28.5205 29.3332 29.3322 28.5667 29.3322 27.6221V22.548V9.99973Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logoHeader.3a6003aab9d5748d5e757f5a183c97e1.svg";
export { ForwardRef as ReactComponent };